import React from "react";
import { GlobalTableStyles } from './globalTableStyles'
import { IrecordingLinks, NoteTableHeaderList } from "../../../Models/applicationModels";
import videoIcon from "../../../Assets/videoIcon.png"
import openIcon from "../../../Assets/openIcon.png"
import { formatUTCDateTime } from "../../../utils/formatUTCDate";
import { recordingLinkTableHeaderList } from "../../../constants/tableHeaderList";

interface IGlobalTableProps {
    reordingData: null | IrecordingLinks[]
}

const RecordingLinkTable = (props: IGlobalTableProps) => {
    const { reordingData } = props

    const {
        tableStyle,
        recordingLinkTableHeader,
        recordingLinkTableCell,
        lastCell,
        linkStyle,
        openIconStyle
    } = GlobalTableStyles().classes

    return (
        <>
            {reordingData && reordingData?.length > 0 &&
                <table className={tableStyle}>
                    <tr>
                        {recordingLinkTableHeaderList?.map((header: NoteTableHeaderList, index: number) => {
                            return (
                                <th
                                    className={`${recordingLinkTableHeader} ${index === recordingLinkTableHeaderList.length - 1 ? lastCell : ""}`}
                                    style={{ width: header.width }}
                                >
                                    {header.headerName}
                                </th>
                            )
                        })}
                    </tr>
                    {reordingData?.map((rowValue: IrecordingLinks, index: number) => (
                        <>
                            <tr key={index}>
                                <td className={recordingLinkTableCell}>
                                    {<img src={videoIcon} />}
                                </td>
                                <td className={recordingLinkTableCell}>
                                    {rowValue.recordingBy}
                                </td>
                                <td className={recordingLinkTableCell}>
                                    {formatUTCDateTime(rowValue.createdOn)}
                                    {/* {rowValue.createdOn} */}
                                </td>
                                <td className={`${recordingLinkTableCell} ${lastCell}`}>
                                    <a href={rowValue.recordingLink} className={linkStyle} target="_blank">
                                        <span>
                                            {rowValue.recordingLink?.length >= 80 ? rowValue.recordingLink.substring(0, 80) + "..." : rowValue.recordingLink}
                                        </span>
                                        <img src={openIcon} alt="" className={openIconStyle} />
                                    </a>
                                </td>
                            </tr>
                        </>
                    ))}
                </table>
            }
        </>
    )
}

export default RecordingLinkTable